import { atom } from "jotai";
import { atomWithImmer } from "jotai/immer";
import { appStateAtom } from "./appState";
import produce from "immer";
export var projectsAtom = atomWithImmer(null);
projectsAtom.debugLabel = "projectsAtom";
/*
	Mutator and selector for these atom
 */

export var currentProject = atom(function (get) {
  var _get = get(appStateAtom),
      selectedProjectId = _get.selectedProjectId;

  var projects = get(projectsAtom);
  if (projects === null) return null;
  return projects === null || projects === void 0 ? void 0 : projects.filter(function (_ref) {
    var id = _ref.id;
    return selectedProjectId === id;
  })[0];
});
/*
	Use to add project instantly.
 */

export var updateCurrentProjectInfoAtom = atom(null, function (get, set, update) {
  var _get2 = get(appStateAtom),
      selectedProjectId = _get2.selectedProjectId;

  var projectList = get(projectsAtom);
  var projects = produce(projectList, function (draftProjects) {
    for (var id in draftProjects) {
      if (draftProjects[id].id === selectedProjectId) {
        draftProjects[id] = update;
      }
    }
  });
  set(projectsAtom, projects);
});